export const defaultModelOptions = {
    text: [
        { alias: 'gpt-4o', label: 'GPT-4o (2024-08-06)', default: true },
        { alias: 'gemini-3.1-pro-preview', label: 'Gemini 3.1 Pro Preview', default: false },
        { alias: 'gemini-2.5-pro', label: 'Gemini 2.5 Pro', default: false },
        { alias: 'gpt-5', label: 'GPT-5', default: false }
    ],
    image: [
        { alias: 'gpt-image-1', label: 'GPT-Image-1', default: true },
        { alias: 'gemini-3-pro-image-preview', label: 'Gemini 3 Pro Image', default: false },
        { alias: 'imagen-4.0-ultra-generate-001', label: 'Imagen 4.0 Ultra', default: false },
        { alias: 'kling-v2-1-image', label: 'Kling v2.1 (T2I)', default: false }
    ],
    video: [
        { alias: 'veo', label: 'Google Veo', default: true },
        { alias: 'sora-2', label: 'Sora 2', default: false },
        { alias: 'kling-2.1', label: 'Kling 2.1 Video', default: false }
    ]
};
